// import { useContext, useEffect, useRef, useState } from "react"; 
// import { IndianRupee } from "lucide-react"; 
// import { FaRupeeSign } from "react-icons/fa"; 
// import { 
//   XMarkIcon, 
//   UserCircleIcon, 
//   Squares2X2Icon, 
//   UsersIcon, 
//   BellIcon, 
//   DocumentTextIcon, 
//   WrenchScrewdriverIcon, 
//   ArrowRightOnRectangleIcon, 
//   Cog6ToothIcon, 
//   BookOpenIcon, 
//   VideoCameraIcon, 
//   QuestionMarkCircleIcon, 
//   CodeBracketIcon, 
//   ArrowTopRightOnSquareIcon, 
//   EnvelopeIcon, 
//   PhoneIcon, 
//   UserIcon 
// } from "@heroicons/react/24/solid"; 
// import { useNavigate, useLocation } from "react-router-dom"; 
// import { AuthContext } from "../context/AuthContext"; 
// import { FaBars } from "react-icons/fa"; 
// import { API_URL } from "../../Constants"; 
// import { Client } from "@stomp/stompjs"; 
// import SockJS from "sockjs-client"; 
// import logo1 from "../assets/wplogo2.png";
// import logo2 from "../assets/lmslogo.png";
// import logo3 from "../assets/ivrlogo.png";

// export default function Navbar({ onToggleSidebarMode, isSidebarOpen, onToggleSidebar }) { 
//   const [showProfileDropdown, setShowProfileDropdown] = useState(false); 
//   const [sidebarMode, setSidebarMode] = useState("lead"); 
//   const [notifications, setNotifications] = useState([]); 
//   const [unreadCount, setUnreadCount] = useState(0); 
//   const [showNotifications, setShowNotifications] = useState(false); 

//   // Pagination States for Notification History
//   const [currentPage, setCurrentPage] = useState(0);
//   const [hasMore, setHasMore] = useState(true);
//   const [isLoadingHistory, setIsLoadingHistory] = useState(false);

//   // Balance API state 
//   const [balance, setBalance] = useState(null); 
//   const [balanceVisible, setBalanceVisible] = useState(false); 

//   // Modals State 
//   const [showDocumentationModal, setShowDocumentationModal] = useState(false); 
//   const [showServicesModal, setShowServicesModal] = useState(false); 
//   const [showContactModal, setShowContactModal] = useState(false); 
//   const [showMobileButtons, setShowMobileButtons] = useState(false); 

//   const { user, logout } = useContext(AuthContext); 
//   const profileDropdownRef = useRef(null); 
//   const notificationRef = useRef(null); 
//   const mobileButtonsRef = useRef(null); 
//   const navigate = useNavigate(); 
//   const location = useLocation(); 

//   const isModalOpen = showDocumentationModal || showServicesModal || showContactModal; 

//   // --- THEME CONSTANTS --- 
//   const NAV_BG = "#0C4550"; 
//   const iconButtonStyles = "text-white/80 hover:bg-white/10 hover:text-white"; 
//   const profileIconStyles = "bg-white/10 border-white/20 text-white hover:bg-white/20"; 
//   const navStyles = `bg-[${NAV_BG}] text-white shadow-lg border-b border-[#C5F637]/20`; 

//   // --- Balance Logic --- 
//   const fetchBalance = async () => { 
//     try { 
//       const token = localStorage.getItem("token"); 
//       const res = await fetch(`${API_URL}/api/v1/wallet/balance`, { 
//         method: "GET", 
//         headers: {  
//             Authorization: `Bearer ${token}`, 
//             "Content-Type": "application/json" 
//         } 
//       }); 

//       if (!res.ok) throw new Error("Failed to fetch balance"); 
        
//       const jsonResponse = await res.json(); 

//       if (jsonResponse.success && jsonResponse.data) { 
//         // Retrieve the balance in milli-paise
//         const amountInMilliPaise = jsonResponse.data.liveBalancePaise || 0; 
        
//         // Convert milli-paise to Rupees (divide by 100,000)
//         const amountInRupees = amountInMilliPaise / 100000; 

//         // Format to always show 2 decimal places (representing the paise value)
//         const formattedRupees = amountInRupees.toLocaleString("en-IN", { 
//           minimumFractionDigits: 2, 
//           maximumFractionDigits: 2, 
//         }); 

//         setBalance(formattedRupees); 
//         setBalanceVisible(true); 
//       } 

//       setTimeout(() => setBalanceVisible(false), 3000); 
//     } catch (error) { 
//       console.error("Balance fetch error:", error); 
//     } 
//   };

//   // --- Sidebar Mode Logic --- 
//   const handleSidebarModeToggle = () => { 
//     const newMode = sidebarMode === "account" ? "lead" : "account"; 
//     setSidebarMode(newMode); 
//     onToggleSidebarMode(newMode); 
//     navigate(newMode === "account" ? "/viewAccount" : "/dashboard"); 
//   }; 

//   useEffect(() => { 
//     if (location.pathname === "/viewAccount") { 
//       setSidebarMode("account"); 
//       onToggleSidebarMode("account"); 
//     } else if (location.pathname === "/dashboard") { 
//       setSidebarMode("lead"); 
//       onToggleSidebarMode("lead"); 
//     } 
//   }, [onToggleSidebarMode, location.pathname]); 

//   // --- HISTORICAL NOTIFICATIONS LOGIC ---
//   const fetchHistoricalNotifications = async (pageToFetch = 0) => {
//     if (isLoadingHistory || (!hasMore && pageToFetch !== 0)) return;
//     setIsLoadingHistory(true);

//     try {
//       const token = localStorage.getItem("token");
//       const res = await fetch(`${API_URL}/api/v1/notifications?page=${pageToFetch}&size=20`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       const json = await res.json();
      
//       if (json.success && json.data) {
//         const pageData = json.data; 
        
//         const fetchedHistory = pageData.content.map(n => ({
//           id: n.id,
//           message: n.message,
//           read: n.isRead,
//           time: new Date(n.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//           data: n.eventData
//         }));
        
//         if (pageToFetch === 0) {
//             setNotifications(fetchedHistory);
//             setUnreadCount(fetchedHistory.filter(n => !n.read).length);
//         } else {
//             setNotifications(prev => [...prev, ...fetchedHistory]);
//         }

//         setHasMore(!pageData.last);
//         setCurrentPage(pageToFetch);
//       }
//     } catch (err) {
//       console.error("Failed to load notification history", err);
//     } finally {
//       setIsLoadingHistory(false);
//     }
//   };

//   // Fetch initial history when user logs in
//   useEffect(() => {
//     if (user?.id) {
//       fetchHistoricalNotifications(0);
//     }
//   }, [user?.id]);


//   // --- REAL-TIME WEBSOCKET NOTIFICATIONS LOGIC --- 
//   useEffect(() => {
//     if (!user?.id) return;

//     const token = localStorage.getItem("token");
//     if (!token) return;

//     const httpUrl = `${API_URL}/ws-endpoint?token=${token}`; 

//     const stompClient = new Client({
//       // Adding transports array forces XHR fallback immediately, avoiding the pure WebSocket error entirely
//       webSocketFactory: () => new SockJS(httpUrl, null, {
//         transports: ['xhr-streaming', 'xhr-polling'] 
//       }),
      
//       connectHeaders: {
//         Authorization: `Bearer ${token}`, 
//       },
      
//       heartbeatIncoming: 4000,
//       heartbeatOutgoing: 4000,
      
//       onConnect: () => {
//         console.log("Connected to Real-Time Notifications via SockJS");

//         // The correct parameterised topic for the logged-in user
//         stompClient.subscribe(`/topic/notifications/${user.id}`, (message) => {
//           if (message.body) {
//             const response = JSON.parse(message.body);
            
//             if (response.success) {
//               const newNotification = {
//                 // If backend sends the DB ID in the response, use it, else fallback to Date.now()
//                 id: response.data?.id || Date.now(), 
//                 message: response.message,
//                 read: false,
//                 time: new Date(response.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//                 data: response.data 
//               };

//               setNotifications((prev) => [newNotification, ...prev]);
//               setUnreadCount((prev) => prev + 1);
//             }
//           }
//         });
//       },
//       onStompError: (frame) => {
//         console.error('Broker reported error: ' + frame.headers['message']);
//       },
//       onWebSocketError: (error) => {
//         console.error('Error with websocket', error);
//       }
//     });

//     stompClient.activate();

//     return () => {
//       stompClient.deactivate();
//     };
//   }, [user?.id]); 

//   const handleMarkAllRead = () => {
//     setNotifications((prev) => prev.map(n => ({ ...n, read: true })));
//     setUnreadCount(0);
//     // Note: You should also call your backend API here to mark them read in MongoDB
//     // fetch(`${API_URL}/api/v1/notifications/mark-read`, { method: "PATCH", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }});
//   };

//   // --- Click Outside Logic --- 
//   useEffect(() => { 
//     const handleClickOutside = (event) => { 
//       if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) { 
//         setShowProfileDropdown(false); 
//       } 
//       if (notificationRef.current && !notificationRef.current.contains(event.target)) { 
//         setShowNotifications(false); 
//       } 
//       if (mobileButtonsRef.current && !mobileButtonsRef.current.contains(event.target)) { 
//         setShowMobileButtons(false); 
//       } 
//     }; 
//     document.addEventListener("mousedown", handleClickOutside); 
//     return () => document.removeEventListener("mousedown", handleClickOutside); 
//   }, []); 

//   const NavButton = ({ icon: Icon, label, onClick }) => ( 
//     <button 
//       onClick={onClick} 
//       className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all backdrop-blur-sm border border-[#C5F637]/20 bg-white/5 text-white hover:bg-[#C5F637]/10 hover:text-[#C5F637] hover:border-[#C5F637]/30`} 
//     > 
//       <Icon className="w-4 h-4" /> 
//       <span>{label}</span> 
//     </button> 
//   ); 

//   return ( 
//     <> 
//       <style>{` 
//         @keyframes fadeInScale { 
//           from { opacity: 0; transform: scale(0.95) translateY(10px); } 
//           to { opacity: 1; transform: scale(1) translateY(0); } 
//         } 
//         .animate-fadeInScale { 
//           animation: fadeInScale 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
//         } 
//       `}</style> 

//       <nav className={`sticky top-0 z-40 w-full transition-all duration-300 ${navStyles} ${isModalOpen ? 'blur-sm' : ''}`}> 
//         <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8"> 
//           <div className="flex justify-between items-center h-16"> 
//             <div className="flex items-center gap-4"> 
//               <button onClick={() => onToggleSidebar(!isSidebarOpen)} className={`p-2 rounded-lg transition-colors ${iconButtonStyles}`}> 
//                 {isSidebarOpen ? <XMarkIcon className="w-6 h-6" /> : <FaBars className="w-5 h-5" />} 
//               </button> 
//             </div> 

//             <div className="hidden md:flex items-center gap-4"> 
//               <button 
//                 onClick={fetchBalance} 
//                 className="flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all backdrop-blur-sm border border-[#C5F637]/20 bg-white/5 text-white hover:bg-[#C5F637]/10 hover:text-[#C5F637] hover:border-[#C5F637]/30 min-w-[140px] justify-center" 
//               > 
//                 {balanceVisible && balance !== null ? ( 
//                   <span className="font-bold text-xl text-[#C5F637] tracking-wide">₹{balance}</span> 
//                 ) : ( 
//                   <><FaRupeeSign className="w-4 h-4" /><span>Balance</span></> 
//                 )} 
//               </button> 
//               <NavButton icon={DocumentTextIcon} label="Docs" onClick={() => setShowDocumentationModal(true)} /> 
//               <NavButton icon={WrenchScrewdriverIcon} label="Services" onClick={() => setShowServicesModal(true)} /> 
//             </div> 

//             <div className="flex items-center gap-3"> 
//               <div className="md:hidden relative" ref={mobileButtonsRef}> 
//                 <button onClick={() => setShowMobileButtons(!showMobileButtons)} className={`p-2 rounded-lg ${iconButtonStyles}`}> 
//                   <Squares2X2Icon className="w-6 h-6" /> 
//                 </button> 
//                 {showMobileButtons && ( 
//                   <div className="absolute right-0 mt-2 w-48 bg-[#0C4550] rounded-xl shadow-xl border border-[#C5F637]/20 py-2 text-white z-50 "> 
//                     <button onClick={fetchBalance} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"> 
//                       {balanceVisible && balance !== null ? <span className="font-semibold text-[#C5F637]">₹{balance}</span> : <><IndianRupee className="w-4 h-4 text-[#C5F637]" /><span>Balance</span></>} 
//                     </button> 
//                     <button onClick={() => setShowDocumentationModal(true)} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"><DocumentTextIcon className="w-4 h-4 text-[#C5F637]" /><span>Docs</span></button> 
//                     <button onClick={() => setShowServicesModal(true)} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"><WrenchScrewdriverIcon className="w-4 h-4 text-[#C5F637]" /><span>Services</span></button> 
//                   </div> 
//                 )} 
//               </div> 

//               {["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(user?.role) && ( 
//                 <button onClick={handleSidebarModeToggle} className={`p-2 rounded-full transition-colors ${iconButtonStyles}`} title="Switch Dashboard View"> 
//                   {sidebarMode === "account" ? <UsersIcon className="w-6 h-6" /> : <Squares2X2Icon className="w-6 h-6" />} 
//                 </button> 
//               )} 

//               {/* --- NOTIFICATION DROPDOWN UI --- */}
//               <div className="relative" ref={notificationRef}> 
//                 <button onClick={() => setShowNotifications(!showNotifications)} className={`p-2 rounded-full relative ${iconButtonStyles}`}> 
//                   <BellIcon className="w-6 h-6" /> 
//                   {unreadCount > 0 && <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-[#C5F637] rounded-full border-2 border-[#0C4550]"></span>} 
//                 </button> 

//                 {showNotifications && ( 
//                   <div className="absolute right-0 mt-3 w-80 bg-[#0C4550] rounded-xl shadow-2xl border border-[#C5F637]/20 overflow-hidden z-50 text-white animate-fadeIn"> 
//                     <div className="px-4 py-3 border-b border-white/10 bg-white/5 flex justify-between items-center"> 
//                       <h3 className="font-bold text-sm">Notifications</h3> 
//                       {notifications.length > 0 && (
//                         <span onClick={handleMarkAllRead} className="text-xs text-[#C5F637] font-semibold cursor-pointer hover:underline">
//                           Mark all read
//                         </span> 
//                       )}
//                     </div> 
//                     <div className="max-h-80 overflow-y-auto"> 
//                       {notifications.length === 0 ? (
//                         <div className="px-4 py-6 text-center text-[#A7A08F] text-xs">
//                           {isLoadingHistory ? 'Loading...' : 'No new notifications'}
//                         </div>
//                       ) : (
//                         <>
//                           {notifications.map(n => ( 
//                             <div key={n.id} className={`px-4 py-3 border-b border-white/5 hover:bg-white/5 cursor-pointer transition-colors ${!n.read ? 'bg-[#C5F637]/5 border-l-2 border-l-[#C5F637]' : ''}`}> 
//                               <p className="text-xs font-medium text-white/90">{n.message}</p> 
//                               <p className="text-[10px] text-[#A7A08F] mt-1">{n.time}</p> 
//                             </div> 
//                           ))}

//                           {/* LOAD MORE BUTTON */}
//                           {hasMore && (
//                             <button 
//                               onClick={(e) => {
//                                 e.stopPropagation(); 
//                                 fetchHistoricalNotifications(currentPage + 1);
//                               }}
//                               disabled={isLoadingHistory}
//                               className="w-full px-4 py-3 text-xs text-center font-bold text-[#C5F637] hover:bg-white/5 transition-colors disabled:opacity-50"
//                             >
//                               {isLoadingHistory ? 'Loading...' : 'Load Older Notifications'}
//                             </button>
//                           )}
//                         </>
//                       )} 
//                     </div> 
//                   </div> 
//                 )} 
//               </div> 

//               <div className="relative ml-2" ref={profileDropdownRef}> 
//                 <button onClick={() => setShowProfileDropdown(!showProfileDropdown)} className="flex items-center gap-2 focus:outline-none"> 
//                   <div className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-colors ${profileIconStyles}`}><UserCircleIcon className="w-6 h-6" /></div> 
//                 </button> 
//                 {showProfileDropdown && ( 
//                   <div className="absolute right-0 mt-3 w-56 bg-[#0C4550] rounded-xl shadow-2xl border border-[#C5F637]/20 overflow-hidden z-50 animate-fadeIn text-white"> 
//                     <div className="px-4 py-4 border-b border-white/10 bg-white/5"> 
//                       <p className="text-sm font-bold text-white">{user?.name || "User"}</p> 
//                       <p className="text-xs text-[#A7A08F] truncate">{user?.email}</p> 
//                     </div> 
//                     <div className="py-1"> 
//                       <button onClick={() => navigate("/profile")} className="w-full px-4 py-2.5 text-left text-sm text-white/80 hover:bg-white/5 flex items-center gap-2"><Cog6ToothIcon className="w-4 h-4 text-[#A7A08F]" /><span>Account Settings</span></button> 
//                       <button onClick={() => { logout(); navigate("/"); }} className="w-full px-4 py-2.5 text-left text-sm text-white hover:bg-[#C5F637]/10 text-[#C5F637] flex items-center gap-2"><ArrowRightOnRectangleIcon className="w-4 h-4" /><span>Sign Out</span></button> 
//                     </div> 
//                   </div> 
//                 )} 
//               </div> 
//             </div> 
//           </div> 
//         </div> 
//       </nav> 

//       {/* --- Documentation Modal --- */} 
//       {showDocumentationModal && ( 
//         <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 transition-all duration-300"> 
//           <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl w-full max-w-lg animate-fadeInScale overflow-hidden "> 
//             <div className="bg-[#0C4550] px-6 py-4 flex justify-between items-center shadow-md"> 
//               <div className="flex items-center gap-3"> 
//                 <div className="p-1.5 bg-[#C5F637]/10 rounded-lg"><DocumentTextIcon className="w-5 h-5 text-[#C5F637]" /></div> 
//                 <div><p className="text-lg font-bold text-white leading-tight">Documentation</p></div> 
//               </div> 
//               <button onClick={() => setShowDocumentationModal(false)} className="text-white/50 hover:text-white p-1.5 rounded-full"><XMarkIcon className="w-6 h-6" /></button> 
//             </div> 
//             <div className="p-6"> 
//               <div className="grid grid-cols-2 gap-4"> 
//                 {[ 
//                   { title: "User Guide", icon: BookOpenIcon, desc: "Step-by-step navigation" }, 
//                   { title: "API Reference", icon: CodeBracketIcon, desc: "Endpoint documentation" }
//                 ].map((item, i) => ( 
//                   <button key={i} onClick={() => { if (item.route) { navigate(item.route); setShowDocumentationModal(false); } }} className="group p-4 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all text-left"> 
//                     <div className="w-10 h-10 bg-[#0C4550]/5 text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-[#C5F637] rounded-lg flex items-center justify-center mb-3 transition-colors"><item.icon className="w-5 h-5" /></div> 
//                     <p className="text-sm font-bold text-[#0C4550] mb-1">{item.title}</p> 
//                     <p className="text-[10px] text-gray-600 font-medium">{item.desc}</p> 
//                   </button> 
//                 ))} 
//               </div> 
//             </div> 
//           </div> 
//         </div> 
//       )} 

//       {/* --- Services Modal --- */} 
//       {showServicesModal && ( 
//         <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 transition-all duration-300"> 
//           <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl w-full max-w-xl animate-fadeInScale overflow-hidden"> 
//             <div className="bg-[#0C4550] px-6 py-4 flex justify-between items-center shadow-md"> 
//               <div className="flex items-center gap-3"> 
//                 <div className="p-1.5 bg-[#C5F637]/10 rounded-lg"><WrenchScrewdriverIcon className="w-5 h-5 text-[#C5F637]" /></div> 
//                 <div> 
//                   <p className="text-lg font-bold text-white leading-tight">Our Services</p> 
//                   <p className="text-[10px] text-[#A7A08F]">Powered by Enterprise Solutions</p> 
//                 </div> 
//               </div> 
//               <button onClick={() => setShowServicesModal(false)} className="text-white/50 hover:text-white p-1.5 rounded-full"><XMarkIcon className="w-6 h-6" /></button> 
//             </div> 

//             <div className="p-6 space-y-4"> 
//               {[ 
//                 { 
//                   name: "LMS", 
//                   title: "Lead Management System", 
//                   logo: logo2, 
//                   url: "https://lms.deetyasoft.com/" 
//                 }, 
//                 { 
//                   name: "IVR", 
//                   title: "IVR Solutions", 
//                   logo: logo3, 
//                   url: "https://www.ivrguru.com/" 
//                 }, 
//                 { 
//                   name: "WhatsApp", 
//                   title: "Official WhatsApp Business API", 
//                   logo: logo1, 
//                   url: "https://nipane.com/", 
//                   extraClass: "ml-1", 
//                   titleClass: "pl-3" 
//                 }, 
//               ].map((service, i) => ( 
//                 <a 
//                   key={i} 
//                   href={service.url} 
//                   target="_blank" 
//                   rel="noopener noreferrer" 
//                   className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-[#0C4550]/40 transition-all group" 
//                 > 
//                   <div className={`flex-shrink-0 w-32 h-16 rounded-lg overflow-hidden flex items-center justify-center transition-transform group-hover:scale-105 ${service.extraClass || ""}`}> 
//                     <img src={service.logo} alt={service.name} className="w-full h-full object-contain p-1" /> 
//                   </div> 

//                   <div className={`flex-grow ${service.titleClass || "px-4"}`}> 
//                     <p className="text-sm font-bold text-slate-800 transition-colors">{service.title}</p> 
//                     <p className="text-[10px] text-slate-600 font-medium">Click to visit website</p> 
//                   </div> 
//                   <div className="flex items-center gap-2 pr-2"> 
//                     <ArrowTopRightOnSquareIcon className="w-5 h-5   bg-[#0C4550] text-[#C5F637]   p-1 rounded-md transition-all" /> 
//                   </div> 
//                 </a> 
//               ))} 

//               <button 
//                 onClick={() => { setShowServicesModal(false); setShowContactModal(true); }} 
//                 className="w-full mt-2 py-4 bg-[#0C4550] text-white rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-[#09353E] transition-colors shadow-lg flex items-center justify-center gap-2" 
//               > 
//                 Explore All Solutions 
//               </button> 
//             </div> 
//           </div> 
//         </div> 
//       )} 

//       {/* --- Contact Inquiry Modal --- */} 
//       {showContactModal && ( 
//         <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-md p-4"> 
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-fadeInScale overflow-hidden"> 
//             <div className="bg-[#0C4550] px-6 py-5 flex justify-between items-center"> 
//               <div className="flex items-center gap-3"> 
//                 <EnvelopeIcon className="w-6 h-6 text-[#C5F637]" /> 
//                 <h3 className="text-xl font-bold text-white">Inquiry Form</h3> 
//               </div> 
//               <button onClick={() => setShowContactModal(false)} className="text-white/60 hover:text-white transition-colors"> 
//                 <XMarkIcon className="w-7 h-7" /> 
//               </button> 
//             </div> 

//             <form className="p-8 space-y-5" onSubmit={(e) => e.preventDefault()}> 
//               <div> 
//                 <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Full Name</label> 
//                 <div className="relative"> 
//                   <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
//                   <input type="text" placeholder="John Doe" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
//                 </div> 
//               </div> 

//               <div> 
//                 <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Email Address</label> 
//                 <div className="relative"> 
//                   <EnvelopeIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
//                   <input type="email" placeholder="john@example.com" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
//                 </div> 
//               </div> 

//               <div> 
//                 <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Phone Number</label> 
//                 <div className="relative"> 
//                   <PhoneIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
//                   <input type="tel" placeholder="+91 00000 00000" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
//                 </div> 
//               </div> 

//               <button type="submit" className="w-full py-4 bg-[#F46653] text-white rounded-xl font-bold text-sm uppercase tracking-widest shadow-lg shadow-[#F46653]/30 transition-all transform active:scale-[0.98] mt-4"> 
//                 Submit 
//               </button> 
//             </form> 
//           </div> 
//         </div> 
//       )} 
//     </> 
//   ); 
// }






import { useContext, useEffect, useRef, useState } from "react"; 
import { IndianRupee } from "lucide-react"; 
import { FaRupeeSign } from "react-icons/fa"; 
import { 
  XMarkIcon, 
  UserCircleIcon, 
  Squares2X2Icon, 
  UsersIcon, 
  BellIcon, 
  DocumentTextIcon, 
  WrenchScrewdriverIcon, 
  ArrowRightOnRectangleIcon, 
  Cog6ToothIcon, 
  BookOpenIcon, 
  VideoCameraIcon, 
  QuestionMarkCircleIcon, 
  CodeBracketIcon, 
  ArrowTopRightOnSquareIcon, 
  EnvelopeIcon, 
  PhoneIcon, 
  UserIcon 
} from "@heroicons/react/24/solid"; 
import { useNavigate, useLocation } from "react-router-dom"; 
import { AuthContext } from "../context/AuthContext"; 
import { FaBars } from "react-icons/fa"; 
import { API_URL } from "../../Constants"; 
import { Client } from "@stomp/stompjs"; 
import SockJS from "sockjs-client"; 
import logo1 from "../assets/wplogo2.png";
import logo2 from "../assets/lmslogo.png";
import logo3 from "../assets/ivrlogo.png";

export default function Navbar({ onToggleSidebarMode, isSidebarOpen, onToggleSidebar }) { 
  const [showProfileDropdown, setShowProfileDropdown] = useState(false); 
  const [sidebarMode, setSidebarMode] = useState("lead"); 
  const [notifications, setNotifications] = useState([]); 
  const [unreadCount, setUnreadCount] = useState(0); 
  const [showNotifications, setShowNotifications] = useState(false); 

  // Pagination States for Notification History
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  // Balance API state 
  const [balance, setBalance] = useState(null); 
  const [balanceVisible, setBalanceVisible] = useState(false); 

  // Modals State 
  const [showDocumentationModal, setShowDocumentationModal] = useState(false); 
  const [showServicesModal, setShowServicesModal] = useState(false); 
  const [showContactModal, setShowContactModal] = useState(false); 
  const [showMobileButtons, setShowMobileButtons] = useState(false); 

  const { user, logout } = useContext(AuthContext); 
  const profileDropdownRef = useRef(null); 
  const notificationRef = useRef(null); 
  const mobileButtonsRef = useRef(null); 
  const navigate = useNavigate(); 
  const location = useLocation(); 

  const isModalOpen = showDocumentationModal || showServicesModal || showContactModal; 

  // --- THEME CONSTANTS --- 
  const NAV_BG = "#0C4550"; 
  const iconButtonStyles = "text-white/80 hover:bg-white/10 hover:text-white"; 
  const profileIconStyles = "bg-white/10 border-white/20 text-white hover:bg-white/20"; 
  const navStyles = `bg-[${NAV_BG}] text-white shadow-lg border-b border-[#C5F637]/20`; 

  // --- Balance Logic --- 
  const fetchBalance = async () => { 
    try { 
      const token = localStorage.getItem("token"); 
      const res = await fetch(`${API_URL}/api/v1/wallet/balance`, { 
        method: "GET", 
        headers: {  
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json" 
        } 
      }); 

      if (!res.ok) throw new Error("Failed to fetch balance"); 
        
      const jsonResponse = await res.json(); 

      if (jsonResponse.success && jsonResponse.data) { 
        // Retrieve the balance in milli-paise
        const amountInMilliPaise = jsonResponse.data.liveBalancePaise || 0; 
        
        // Convert milli-paise to Rupees (divide by 100,000)
        const amountInRupees = amountInMilliPaise / 100000; 

        // Format to always show 2 decimal places (representing the paise value)
        const formattedRupees = amountInRupees.toLocaleString("en-IN", { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2, 
        }); 

        setBalance(formattedRupees); 
        setBalanceVisible(true); 
      } 

      setTimeout(() => setBalanceVisible(false), 3000); 
    } catch (error) { 
      console.error("Balance fetch error:", error); 
    } 
  };

  // --- Sidebar Mode Logic --- 
  const handleSidebarModeToggle = () => { 
    const newMode = sidebarMode === "account" ? "lead" : "account"; 
    setSidebarMode(newMode); 
    onToggleSidebarMode(newMode); 
    navigate(newMode === "account" ? "/viewAccount" : "/dashboard"); 
  }; 

  useEffect(() => { 
    if (location.pathname === "/viewAccount") { 
      setSidebarMode("account"); 
      onToggleSidebarMode("account"); 
    } else if (location.pathname === "/dashboard") { 
      setSidebarMode("lead"); 
      onToggleSidebarMode("lead"); 
    } 
  }, [onToggleSidebarMode, location.pathname]); 

  // --- HISTORICAL NOTIFICATIONS LOGIC ---
  const fetchHistoricalNotifications = async (pageToFetch = 0) => {
    if (isLoadingHistory || (!hasMore && pageToFetch !== 0)) return;
    setIsLoadingHistory(true);

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/v1/notifications?page=${pageToFetch}&size=20`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const json = await res.json();
      
      if (json.success && json.data) {
        const pageData = json.data; 
        
        const fetchedHistory = pageData.content.map(n => ({
          id: n.id,
          message: n.message,
          read: n.isRead,
          time: new Date(n.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          data: n.eventData
        }));
        
        if (pageToFetch === 0) {
            setNotifications(fetchedHistory);
            setUnreadCount(fetchedHistory.filter(n => !n.read).length);
        } else {
            setNotifications(prev => [...prev, ...fetchedHistory]);
        }

        setHasMore(!pageData.last);
        setCurrentPage(pageToFetch);
      }
    } catch (err) {
      console.error("Failed to load notification history", err);
    } finally {
      setIsLoadingHistory(false);
    }
  };

  // Fetch initial history when user logs in
  useEffect(() => {
    if (user?.id) {
      fetchHistoricalNotifications(0);
    }
  }, [user?.id]);


  // --- REAL-TIME WEBSOCKET NOTIFICATIONS LOGIC --- 
  useEffect(() => {
    if (!user?.id) return;

    const token = localStorage.getItem("token");
    if (!token) return;

    const httpUrl = `${API_URL}/ws-endpoint?token=${token}`; 

    const stompClient = new Client({
      // Adding transports array forces XHR fallback immediately, avoiding the pure WebSocket error entirely
      webSocketFactory: () => new SockJS(httpUrl, null, {
        transports: ['xhr-streaming', 'xhr-polling'] 
      }),
      
      connectHeaders: {
        Authorization: `Bearer ${token}`, 
      },
      
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      
      onConnect: () => {
        console.log("Connected to Real-Time Notifications via SockJS");

        // The correct parameterised topic for the logged-in user
        stompClient.subscribe(`/topic/notifications/${user.id}`, (message) => {
          if (message.body) {
            const response = JSON.parse(message.body);
            
            if (response.success) {
              const newNotification = {
                // If backend sends the DB ID in the response, use it, else fallback to Date.now()
                id: response.data?.id || Date.now(), 
                message: response.message,
                read: false,
                time: new Date(response.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                data: response.data 
              };

              setNotifications((prev) => [newNotification, ...prev]);
              setUnreadCount((prev) => prev + 1);
            }
          }
        });
      },
      onStompError: (frame) => {
        console.error('Broker reported error: ' + frame.headers['message']);
      },
      onWebSocketError: (error) => {
        console.error('Error with websocket', error);
      }
    });

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, [user?.id]); 

  const handleMarkAllRead = () => {
    setNotifications((prev) => prev.map(n => ({ ...n, read: true })));
    setUnreadCount(0);
    // Note: You should also call your backend API here to mark them read in MongoDB
    // fetch(`${API_URL}/api/v1/notifications/mark-read`, { method: "PATCH", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }});
  };

  // --- Click Outside Logic --- 
  useEffect(() => { 
    const handleClickOutside = (event) => { 
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) { 
        setShowProfileDropdown(false); 
      } 
      if (notificationRef.current && !notificationRef.current.contains(event.target)) { 
        setShowNotifications(false); 
      } 
      if (mobileButtonsRef.current && !mobileButtonsRef.current.contains(event.target)) { 
        setShowMobileButtons(false); 
      } 
    }; 
    document.addEventListener("mousedown", handleClickOutside); 
    return () => document.removeEventListener("mousedown", handleClickOutside); 
  }, []); 

  const NavButton = ({ icon: Icon, label, onClick }) => ( 
    <button 
      onClick={onClick} 
      className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all backdrop-blur-sm border border-[#C5F637]/20 bg-white/5 text-white hover:bg-[#C5F637]/10 hover:text-[#C5F637] hover:border-[#C5F637]/30`} 
    > 
      <Icon className="w-4 h-4" /> 
      <span>{label}</span> 
    </button> 
  ); 

  return ( 
    <> 
      <style>{` 
        @keyframes fadeInScale { 
          from { opacity: 0; transform: scale(0.95) translateY(10px); } 
          to { opacity: 1; transform: scale(1) translateY(0); } 
        } 
        .animate-fadeInScale { 
          animation: fadeInScale 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
        } 
      `}</style> 

      <nav className={`sticky top-0 z-40 w-full transition-all duration-300 ${navStyles} ${isModalOpen ? 'blur-sm' : ''}`}> 
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="flex justify-between items-center h-16"> 
            <div className="flex items-center gap-4"> 
              <button onClick={() => onToggleSidebar(!isSidebarOpen)} className={`p-2 rounded-lg transition-colors ${iconButtonStyles}`}> 
                {isSidebarOpen ? <XMarkIcon className="w-6 h-6" /> : <FaBars className="w-5 h-5" />} 
              </button> 
            </div> 

            <div className="hidden md:flex items-center gap-4"> 
              <button 
                onClick={fetchBalance} 
                className="flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all backdrop-blur-sm border border-[#C5F637]/20 bg-white/5 text-white hover:bg-[#C5F637]/10 hover:text-[#C5F637] hover:border-[#C5F637]/30 min-w-[140px] justify-center" 
              > 
                {balanceVisible && balance !== null ? ( 
                  <span className="font-bold text-xl text-[#C5F637] tracking-wide">₹{balance}</span> 
                ) : ( 
                  <><FaRupeeSign className="w-4 h-4" /><span>Balance</span></> 
                )} 
              </button> 
              <NavButton icon={DocumentTextIcon} label="Docs" onClick={() => setShowDocumentationModal(true)} /> 
              <NavButton icon={WrenchScrewdriverIcon} label="Services" onClick={() => setShowServicesModal(true)} /> 
            </div> 

            <div className="flex items-center gap-3"> 
              <div className="md:hidden relative" ref={mobileButtonsRef}> 
                <button onClick={() => setShowMobileButtons(!showMobileButtons)} className={`p-2 rounded-lg ${iconButtonStyles}`}> 
                  <Squares2X2Icon className="w-6 h-6" /> 
                </button> 
                {showMobileButtons && ( 
                  <div className="absolute right-0 mt-2 w-48 bg-[#0C4550] rounded-xl shadow-xl border border-[#C5F637]/20 py-2 text-white z-50 "> 
                    <button onClick={fetchBalance} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"> 
                      {balanceVisible && balance !== null ? <span className="font-semibold text-[#C5F637]">₹{balance}</span> : <><IndianRupee className="w-4 h-4 text-[#C5F637]" /><span>Balance</span></>} 
                    </button> 
                    <button onClick={() => setShowDocumentationModal(true)} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"><DocumentTextIcon className="w-4 h-4 text-[#C5F637]" /><span>Docs</span></button> 
                    <button onClick={() => setShowServicesModal(true)} className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm font-semibold"><WrenchScrewdriverIcon className="w-4 h-4 text-[#C5F637]" /><span>Services</span></button> 
                  </div> 
                )} 
              </div> 

              {["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(user?.role) && ( 
                <button onClick={handleSidebarModeToggle} className={`p-2 rounded-full transition-colors ${iconButtonStyles}`} title="Switch Dashboard View"> 
                  {sidebarMode === "account" ? <UsersIcon className="w-6 h-6" /> : <Squares2X2Icon className="w-6 h-6" />} 
                </button> 
              )} 

              {/* --- NOTIFICATION DROPDOWN UI --- */}
              <div className="relative" ref={notificationRef}> 
                <button onClick={() => setShowNotifications(!showNotifications)} className={`p-2 rounded-full relative ${iconButtonStyles}`}> 
                  <BellIcon className="w-6 h-6" /> 
                  {unreadCount > 0 && <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-[#C5F637] rounded-full border-2 border-[#0C4550]"></span>} 
                </button> 

                {showNotifications && ( 
                  <div className="absolute right-0 mt-3 w-80 bg-[#0C4550] rounded-xl shadow-2xl border border-[#C5F637]/20 overflow-hidden z-50 text-white animate-fadeIn"> 
                    <div className="px-4 py-3 border-b border-white/10 bg-white/5 flex justify-between items-center"> 
                      <h3 className="font-bold text-sm">Notifications</h3> 
                      {notifications.length > 0 && (
                        <span onClick={handleMarkAllRead} className="text-xs text-[#C5F637] font-semibold cursor-pointer hover:underline">
                          Mark all read
                        </span> 
                      )}
                    </div> 
                    <div className="max-h-80 overflow-y-auto"> 
                      {notifications.length === 0 ? (
                        <div className="px-4 py-6 text-center text-[#A7A08F] text-xs">
                          {isLoadingHistory ? 'Loading...' : 'No new notifications'}
                        </div>
                      ) : (
                        <>
                          {notifications.map(n => ( 
                            <div key={n.id} className={`px-4 py-3 border-b border-white/5 hover:bg-white/5 cursor-pointer transition-colors ${!n.read ? 'bg-[#C5F637]/5 border-l-2 border-l-[#C5F637]' : ''}`}> 
                              <p className="text-xs font-medium text-white/90">{n.message}</p> 
                              <p className="text-[10px] text-[#A7A08F] mt-1">{n.time}</p> 
                            </div> 
                          ))}

                          {/* LOAD MORE BUTTON */}
                          {hasMore && (
                            <button 
                              onClick={(e) => {
                                e.stopPropagation(); 
                                fetchHistoricalNotifications(currentPage + 1);
                              }}
                              disabled={isLoadingHistory}
                              className="w-full px-4 py-3 text-xs text-center font-bold text-[#C5F637] hover:bg-white/5 transition-colors disabled:opacity-50"
                            >
                              {isLoadingHistory ? 'Loading...' : 'Load Older Notifications'}
                            </button>
                          )}
                        </>
                      )} 
                    </div> 
                  </div> 
                )} 
              </div> 

              <div className="relative ml-2" ref={profileDropdownRef}> 
                <button onClick={() => setShowProfileDropdown(!showProfileDropdown)} className="flex items-center gap-2 focus:outline-none"> 
                  <div className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-colors ${profileIconStyles}`}><UserCircleIcon className="w-6 h-6" /></div> 
                </button> 
                {showProfileDropdown && ( 
                  <div className="absolute right-0 mt-3 w-56 bg-[#0C4550] rounded-xl shadow-2xl border border-[#C5F637]/20 overflow-hidden z-50 animate-fadeIn text-white"> 
                    <div className="px-4 py-4 border-b border-white/10 bg-white/5"> 
                      <p className="text-sm font-bold text-white">{user?.name || "User"}</p> 
                      <p className="text-xs text-[#A7A08F] truncate">{user?.email}</p> 
                    </div> 
                    <div className="py-1"> 
                      <button onClick={() => navigate("/profile")} className="w-full px-4 py-2.5 text-left text-sm text-white/80 hover:bg-white/5 flex items-center gap-2"><Cog6ToothIcon className="w-4 h-4 text-[#A7A08F]" /><span>Account Settings</span></button> 
                      <button onClick={() => { logout(); navigate("/"); }} className="w-full px-4 py-2.5 text-left text-sm text-white hover:bg-[#C5F637]/10 text-[#C5F637] flex items-center gap-2"><ArrowRightOnRectangleIcon className="w-4 h-4" /><span>Sign Out</span></button> 
                    </div> 
                  </div> 
                )} 
              </div> 
            </div> 
          </div> 
        </div> 
      </nav> 

      {/* --- Documentation Modal --- */} 
      {showDocumentationModal && ( 
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 transition-all duration-300"> 
          <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl w-full max-w-lg animate-fadeInScale overflow-hidden "> 
            <div className="bg-[#0C4550] px-6 py-4 flex justify-between items-center shadow-md"> 
              <div className="flex items-center gap-3"> 
                <div className="p-1.5 bg-[#C5F637]/10 rounded-lg"><DocumentTextIcon className="w-5 h-5 text-[#C5F637]" /></div> 
                <div><p className="text-lg font-bold text-white leading-tight">Documentation</p></div> 
              </div> 
              <button onClick={() => setShowDocumentationModal(false)} className="text-white/50 hover:text-white p-1.5 rounded-full"><XMarkIcon className="w-6 h-6" /></button> 
            </div> 
            <div className="p-6"> 
              <div className="grid grid-cols-2 gap-4"> 
                {[ 
                  { title: "User Guide", icon: BookOpenIcon, desc: "Step-by-step navigation", route: "/user-guide" }, 
                  { title: "API Reference", icon: CodeBracketIcon, desc: "Endpoint documentation", route: "/api-reference" }
                ].map((item, i) => ( 
                  <button key={i} onClick={() => { if (item.route) { navigate(item.route); setShowDocumentationModal(false); } }} className="group p-4 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all text-left"> 
                    <div className="w-10 h-10 bg-[#0C4550]/5 text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-[#C5F637] rounded-lg flex items-center justify-center mb-3 transition-colors"><item.icon className="w-5 h-5" /></div> 
                    <p className="text-sm font-bold text-[#0C4550] mb-1">{item.title}</p> 
                    <p className="text-[10px] text-gray-600 font-medium">{item.desc}</p> 
                  </button> 
                ))} 
              </div> 
            </div> 
          </div> 
        </div> 
      )} 

      {/* --- Services Modal --- */} 
      {showServicesModal && ( 
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 transition-all duration-300"> 
          <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl w-full max-w-xl animate-fadeInScale overflow-hidden"> 
            <div className="bg-[#0C4550] px-6 py-4 flex justify-between items-center shadow-md"> 
              <div className="flex items-center gap-3"> 
                <div className="p-1.5 bg-[#C5F637]/10 rounded-lg"><WrenchScrewdriverIcon className="w-5 h-5 text-[#C5F637]" /></div> 
                <div> 
                  <p className="text-lg font-bold text-white leading-tight">Our Services</p> 
                  <p className="text-[10px] text-[#A7A08F]">Powered by Enterprise Solutions</p> 
                </div> 
              </div> 
              <button onClick={() => setShowServicesModal(false)} className="text-white/50 hover:text-white p-1.5 rounded-full"><XMarkIcon className="w-6 h-6" /></button> 
            </div> 

            <div className="p-6 space-y-4"> 
              {[ 
                { 
                  name: "LMS", 
                  title: "Lead Management System", 
                  logo: logo2, 
                  url: "https://lms.deetyasoft.com/" 
                }, 
                { 
                  name: "IVR", 
                  title: "IVR Solutions", 
                  logo: logo3, 
                  url: "https://www.ivrguru.com/" 
                }, 
                { 
                  name: "WhatsApp", 
                  title: "Official WhatsApp Business API", 
                  logo: logo1, 
                  url: "https://nipane.com/", 
                  extraClass: "ml-1", 
                  titleClass: "pl-3" 
                }, 
              ].map((service, i) => ( 
                <a 
                  key={i} 
                  href={service.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-[#0C4550]/40 transition-all group" 
                > 
                  <div className={`flex-shrink-0 w-32 h-16 rounded-lg overflow-hidden flex items-center justify-center transition-transform group-hover:scale-105 ${service.extraClass || ""}`}> 
                    <img src={service.logo} alt={service.name} className="w-full h-full object-contain p-1" /> 
                  </div> 

                  <div className={`flex-grow ${service.titleClass || "px-4"}`}> 
                    <p className="text-sm font-bold text-slate-800 transition-colors">{service.title}</p> 
                    <p className="text-[10px] text-slate-600 font-medium">Click to visit website</p> 
                  </div> 
                  <div className="flex items-center gap-2 pr-2"> 
                    <ArrowTopRightOnSquareIcon className="w-5 h-5   bg-[#0C4550] text-[#C5F637]   p-1 rounded-md transition-all" /> 
                  </div> 
                </a> 
              ))} 

              <button 
                onClick={() => { setShowServicesModal(false); setShowContactModal(true); }} 
                className="w-full mt-2 py-4 bg-[#0C4550] text-white rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-[#09353E] transition-colors shadow-lg flex items-center justify-center gap-2" 
              > 
                Explore All Solutions 
              </button> 
            </div> 
          </div> 
        </div> 
      )} 

      {/* --- Contact Inquiry Modal --- */} 
      {showContactModal && ( 
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-md p-4"> 
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-fadeInScale overflow-hidden"> 
            <div className="bg-[#0C4550] px-6 py-5 flex justify-between items-center"> 
              <div className="flex items-center gap-3"> 
                <EnvelopeIcon className="w-6 h-6 text-[#C5F637]" /> 
                <h3 className="text-xl font-bold text-white">Inquiry Form</h3> 
              </div> 
              <button onClick={() => setShowContactModal(false)} className="text-white/60 hover:text-white transition-colors"> 
                <XMarkIcon className="w-7 h-7" /> 
              </button> 
            </div> 

            <form className="p-8 space-y-5" onSubmit={(e) => e.preventDefault()}> 
              <div> 
                <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Full Name</label> 
                <div className="relative"> 
                  <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
                  <input type="text" placeholder="John Doe" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
                </div> 
              </div> 

              <div> 
                <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Email Address</label> 
                <div className="relative"> 
                  <EnvelopeIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
                  <input type="email" placeholder="john@example.com" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
                </div> 
              </div> 

              <div> 
                <label className="block text-xs font-bold text-[#0C4550] uppercase tracking-wider mb-2">Phone Number</label> 
                <div className="relative"> 
                  <PhoneIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> 
                  <input type="tel" placeholder="+91 00000 00000" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all text-sm" /> 
                </div> 
              </div> 

              <button type="submit" className="w-full py-4 bg-[#F46653] text-white rounded-xl font-bold text-sm uppercase tracking-widest shadow-lg shadow-[#F46653]/30 transition-all transform active:scale-[0.98] mt-4"> 
                Submit 
              </button> 
            </form> 
          </div> 
        </div> 
      )} 
    </> 
  ); 
}